<template>
    <div :id="match.id" class="Match" :class=" { 'Match__oop__live' : matchState(match.detail.state) === 'Live Match' } ">

        <div class="Match__head__time generic-small" v-if="mode == 'live' && matchState(match.detail.state) != 'Live Match' " :class="{'notBefore_empty' : !displayNotBefore(match.notBefore) }" >
            {{displayNotBefore(match.notBefore)}}
        </div>

        <div class="Match__body">

            <div class="Match__head generic-small" v-if="mode != 'draws'">
                <div class="Match__head__type">
                    {{eventType(match.id)}}
                </div>
                <div class="Match__head__bottom">
                    <div class="Match__head__court">
                        {{courtDisplay(match.detail.crt)}} - {{roundDisplay(match.detail.rnd, match.id)}}
                    </div>
                    <div class="Match__head__state" :class="{ 'live-match' : matchState(match.detail.state) === 'Live Match'}">
                        {{matchState(match.detail.state)}}
                    </div>
                </div>

            </div>

            <div class="Match__line" :class="{ 'Match__line--winner': winner(match.detail.winner , 'a') }">

                <div class="Match__player__holder" v-if="verifyKnownPlayer(0)">

                    <div class="Match__player">

                        <img class="small-flag" :src="flagPath + match.detail.cA.toLowerCase() + '.svg'"
                             :alt="match.detail.cA">

                        <span class="Match__player__fn generic-medium">{{match.detail.nAF}}</span><span class="Match__player__i generic-medium">{{initial(match.detail.nAF)}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{match.detail.nAL}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedA">[{{match.detail.seedA}}]</span>
                        <!-- <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idA )">[Q]</span> -->
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idA )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="forceDoubeCheck()">

                        <img class="small-flag" :src="flagPath + match.detail.cA2.toLowerCase() + '.svg'"
                             :alt="match.detail.cA2">

                        <span class="Match__player__fn generic-medium">{{match.detail.nA2F}}</span><span class="Match__player__i generic-medium">{{initial(match.detail.nA2F)}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{match.detail.nA2L}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedA">[{{match.detail.seedA}}]</span>
                        <!-- <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idA2 )">[Q]</span> -->
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idA2 )">[WC]</span>

                    </div>

                </div>

                <div class="Match__player__holder" v-else>
                    <div class="Match__player">
                        <span class="Match__player__fn generic-medium">TBD</span>
                    </div>
                </div>

                <div v-if="match.detail.serve == '0' || match.detail.serve == '2'"
                     class="Match__serve" v-html="ico_ball">
                </div>

                <div v-if="winner(match.detail.winner , 'a')"
                     class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set generic-medium">

                    <ul>
                        <li class="Match__set__pt" v-if="match.detail.ptA">{{match.detail.ptA}}</li>
                        <li v-if="match.detail.s1A" :class="{Match__set__winner : parseInt(match.detail.s1A) > parseInt(match.detail.s1B)}">
                            {{match.detail.s1A}}<sup v-if="match.detail.s1A < match.detail.s1B">{{match.detail.tb1}}</sup>
                        </li>
                        <li v-else>-</li>
                        <li v-if="match.detail.s2A" :class="{Match__set__winner : parseInt(match.detail.s2A) > parseInt(match.detail.s2B)}">
                            {{match.detail.s2A}}<sup v-if="match.detail.s2A < match.detail.s2B">{{match.detail.tb2}}</sup>
                        </li>
                        <li v-else>-</li>
                        <li v-if="match.detail.s3A" :class="{Match__set__winner : parseInt(match.detail.s3A) > parseInt(match.detail.s3B)}">
                            {{match.detail.s3A}}<sup v-if="match.detail.s3A < match.detail.s3B">{{match.detail.tb3}}</sup>
                        </li>
                        <li v-else>-</li>
                    </ul>

                </div>

            </div>

            <div class="Match__line" :class="{ 'Match__line--winner': winner(match.detail.winner , 'b') }">

                <div class="Match__player__holder" v-if="verifyKnownPlayer(1)">

                    <div class="Match__player">

                        <img class="small-flag" :src="flagPath + match.detail.cB.toLowerCase() + '.svg'"
                             :alt="match.detail.cB">

                        <span class="Match__player__fn generic-medium">{{match.detail.nBF}}</span><span class="Match__player__i generic-medium">{{initial(match.detail.nBF)}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{match.detail.nBL}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedB">[{{match.detail.seedB}}]</span>
                        <!-- <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idB )">[Q]</span> -->
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idB )">[WC]</span>

                    </div>

                    <div class="Match__player" v-if="forceDoubeCheck()">

                        <img class="small-flag" :src="flagPath + match.detail.cB2.toLowerCase() + '.svg'"
                             :alt="match.detail.cB2">

                        <span class="Match__player__fn generic-medium">{{match.detail.nB2F}}</span><span class="Match__player__i generic-medium">{{initial(match.detail.nB2F)}}</span>&nbsp;<span
                            class="Match__player__ln generic-medium">{{match.detail.nB2L}}</span>
                        <span class="Match__player__seed"
                              v-if="match.detail.seedB">[{{match.detail.seedB}}]</span>
                        <!-- <span class="Match__player__seed"
                              v-if="showType( 'q', match.detail.idB2 )">[Q]</span> -->
                        <span class="Match__player__seed"
                              v-if="showType( 'wc', match.detail.idB2 )">[WC]</span>

                    </div>

                </div>

                <div class="Match__player__holder" v-else>
                    <div class="Match__player">
                        <span class="Match__player__fn generic-medium">TBD</span>
                    </div>
                </div>


                <div v-if="match.detail.serve == '1' || match.detail.serve == '3'"
                     class="Match__serve" v-html="ico_ball">
                </div>

                <div v-if="winner(match.detail.winner , 'b')"
                     class="Match__winner" v-html="ico_winner"></div>

                <div class="Match__set generic-medium">

                    <ul>

                        <li class="Match__set__pt" v-if="match.detail.ptB">{{match.detail.ptB}}</li>
                        <li v-if="match.detail.s1B" :class="{Match__set__winner : parseInt(match.detail.s1A) < parseInt(match.detail.s1B)}">
                            {{match.detail.s1B}}<sup v-if="match.detail.s1A > match.detail.s1B">{{match.detail.tb1}}</sup>
                        </li>
                        <li v-else>-</li>
                        <li v-if="match.detail.s2B" :class="{Match__set__winner : parseInt(match.detail.s2A) < parseInt(match.detail.s2B)}">
                            {{match.detail.s2B}}<sup v-if="match.detail.s2A > match.detail.s2B">{{match.detail.tb2}}</sup>
                        </li>
                        <li v-else>-</li>
                        <li v-if="match.detail.s3B" :class="{Match__set__winner : parseInt(match.detail.s3A) < parseInt(match.detail.s3B)}">
                            {{match.detail.s3B}}<sup v-if="match.detail.s3A > match.detail.s3B">{{match.detail.tb3}}</sup>
                        </li>
                        <li v-else>-</li>

                    </ul>

                </div>

            </div>

        </div>

        <div class="Match__meta">

            <div class="Match__time general-button grey-blue generic-small pdf_downloads">
                <span v-html="ico_clock"></span>
                {{matchTime(match.detail.mt)}}
            </div>


            <a :href="detail + '?match=' + match.id" class="Match__link general-button grey-blue generic-small pdf_downloads" v-if="showStat(match)">
                Match&nbsp;stats
            </a>

            <a class="Match__link general-button grey-blue generic-small pdf_downloads" :href="ticket" v-else>
                Get tickets
            </a>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        props: ['match', 'flagPath', 'detail', 'mode', 'type', 'ticket'],
        data() {
            return {
                ico_winner : window.ico_tick,
                ico_ball   : window.ico_ball,
                ico_clock  : window.ico_clock,
                to_display : this.match,
                checkLive  : null,
            }
        },

        created() {

            if(this.mode == 'draws' || this.mode == 'result'){
                this.getMatch()

                let app = this
                this.checkLive = setInterval(function () {

                    if( app.match.detail.state == 'P'){

                        app.getMatch()
                    } else {
                        clearInterval(app.checkLive)
                    }

                }, 15 * 1000, app)

            }

        },
        methods: {
            verifyKnownPlayer(value){
                if(this.match.team){
                    if( this.match.team[value] && this.match.team[value].playersKnown ){
                        return true
                    }else{
                        return false
                    }
                }
                return true;
            },
            winner(winner, team) {
                if (team == 'a' && (winner == '2' || winner == '4' || winner == '6')) {
                    return true
                }
                if(team == 'a' && winner != '' && (winner == this.match.detail.idA  )) {
                    return true
                }

                if (team == 'b' && (winner == '3' || winner == '5' || winner == '7')) {
                    return true
                }
                if(team == 'b' && winner != '' && (winner== this.match.detail.idB )) {
                    return true
                }

                return false
            },
            matchTime(time) {
                //this was before
                if(time.length < 1){
                    return '00:00'
                }

                if (time.length < 6) {
                    return time + ':00'
                }

                return time.slice(0, 5);
            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            eventType(matchID){
                if(matchID.includes('MS')){
                    return "Men's Singles"
                }else if(matchID.includes('MD')){
                    return "Men's Doubles"
                }else if(matchID.includes('QS')){
                    return "Men's Singles Qualifying"
                }else if(matchID.includes('QD')){
                    return "Men's Doubles Qualifying"
                }else if(matchID.includes('LS')){
                    return "Women's Singles"
                }else if(matchID.includes('LD')){
                    return "Women's Doubles"
                }else if(matchID.includes('RS')){
                    return "Women's Singles Qualifying"
                }
            },
            assocType(matchID){
                if(matchID.includes('MS') || matchID.includes('MD') || matchID.includes('QS') || matchID.includes('QD')){
                    return "atp"
                }else if(matchID.includes('LS') || matchID.includes('LD') || matchID.includes('RS')){
                    return "wta"
                }
            },
            roundDisplay(round, matchId) {
                // if (round == '1' || round == 'R32' || round == 'First Round' || round == 'R64')
                //     return 'Round 1'
                // else if (round == '2' || round == 'R16' || round == 'Second Round')
                //     return 'Round 2'
                // else if (round == '3')
                //     return 'Round 3'
                //
                // if (this.type == 'wta') {
                //
                //     if (round == 'Q')
                //         return 'Quarterfinals'
                //     else if (round == 'S')
                //         return 'Semifinals'
                //     else if (round == 'F')
                //         return 'Final'
                // } else {
                //     if (round == '5')
                //         return 'Quarterfinals'
                //     else if (round == '6')
                //         return 'Semifinals'
                //     else if (round == '7')
                //         return 'Final'
                // }
                //
                // if(round == 'F')
                //     return 'Final'
                //
                // if ( round == 'Q1' || round == 'R1' )
                //     return 'Round 1'
                // else if ( round == 'Q2' || round == 'R2' || round == "Q4" )
                //     return 'Round 2'


                const idNumber = parseInt(matchId.slice(2), 10);

                if(matchId.toLowerCase().includes('ls') || matchId.toLowerCase().includes('ms')){
                    round = 'Final'

                    if(idNumber >= 2){
                        round = 'Semifinals'
                    }
                    if(idNumber >= 4){
                        round = 'Quarterfinals'
                    }
                    if(idNumber >= 8){
                        round = 'Round 3'
                    }
                    if(idNumber >= 16){
                        round = 'Round 2'
                    }
                    if(idNumber >= 32){
                        round = 'Round 1'
                    }

                }else if(matchId.toLowerCase().includes('ld') || matchId.toLowerCase().includes('md')){
                    round = 'Final'

                    if(idNumber >= 2){
                        round = 'Semifinals'
                    }
                    if(idNumber >= 4){
                        round = 'Quarterfinals'
                    }
                    if(idNumber >= 8){
                        round = 'Round 2'
                    }
                    if(idNumber >= 16){
                        round = 'Round 1'
                    }

                }else if(matchId.toLowerCase().includes('rs') || matchId.toLowerCase().includes('qs')){

                    round = 'Round 2'
                    if(idNumber >= 16){
                        round = 'Round 1'
                    }

                }

                return round;
            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            isQualifying() {
                if ( this.to_display.detail.isQuals == '1' )
                    return 'qualifying'
                else
                    return 'main draw'
            },
            messageFormat(detail) {

                if (detail.msg == '') {
                    return ''
                }

                let messages = detail.msg.match(/{(.*?)}/)
                let messageParts = messages[0].slice(1, -1).split('|')

                if (messageParts[0] == '1') {
                    return 'Match point'
                }

                if (messageParts[0] == '2') {
                    return `${messageParts[1]} match points`
                }

                if (messageParts[0] == '3') {
                    return 'Break point'
                }

                if (messageParts[0] == '4') {
                    return `${messageParts[1]} break points`
                }

                if (messageParts[0] == '5') {
                    return 'Set point'
                }

                if (messageParts[0] == '6') {
                    return `${messageParts[1]} set points`
                }

                if (messageParts[0] == '7') {
                    return '2nd serve'
                }

                if (messageParts[0] == '8') {
                    return `Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '9') {
                    return `Ace  - ${messageParts[1]} for ${messageParts[2]}`
                }
                if (messageParts[0] == '10') {
                    return `Ace on 2nd serve – ace #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '11') {
                    return ''
                    return `Winner: ${messageParts[1]}`
                }

                if (messageParts[0] == '12') {
                    return ''
                    return `Winners ${messageParts[1]}`
                }

                if (messageParts[0] == '13') {
                    return `Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '14') {
                    return `Ace ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '15') {
                    return `Ace on 2nd serve ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '16') {
                    return 'Match suspended – rain'
                }

                if (messageParts[0] == '17') {
                    return 'Match suspended – darkness'
                }

                if (messageParts[0] == '18') {
                    return 'Match suspended – heat'
                }

                if (messageParts[0] == '19') {
                    return 'Match suspended'
                }

                if (messageParts[0] == '20') {
                    return 'by retirement'
                }

                if (messageParts[0] == '21') {
                    return `Point penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '22') {
                    return `Game penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '23') {
                    return `Time penalty against ${messageParts[1]}`
                }

                if (messageParts[0] == '24') {
                    return 'by default'
                }

                if (messageParts[0] == '25') {
                    return 'Game point'
                }

                if (messageParts[0] == '26') {
                    return `${messageParts[1]} game points`
                }

                if (messageParts[0] == '27') {
                    return 'Foot fault – 2nd serve'
                }

                if (messageParts[0] == '28') {
                    return `Foot fault – Double fault #${messageParts[1]} for ${messageParts[2]}`
                }

                if (messageParts[0] == '29') {
                    return `Foot fault – Double fault ${messageParts[1]} - #${messageParts[2]} for the team`
                }

                if (messageParts[0] == '30') {
                    return 'Let'
                }

                return ''

            },
            displayNotBefore(notBefore) {

                if(notBefore){

                    if (notBefore.text == notBefore.time) {
                        return notBefore.time
                    }

                    if(notBefore.time == '' && notBefore.isoTime != '' ){
                        return notBefore.text + ' ' + this.parseTime(notBefore.isoTime)
                    }

                    if(notBefore.isoTime != '' && notBefore.text != ''){
                        return notBefore.text + ' ' + this.parseTime(notBefore.isoTime)
                    }

                    if (notBefore.text == 'Not Before' && notBefore.time != '') {
                        return notBefore.time
                    }

                    return `${notBefore.text}  ${notBefore.time}`

                } else{
                    return false
                }


            },
            parseTime( isoTime ){
                var time = new moment(isoTime, 'HH:mm:ss')

                return time.format( 'h:mm a' )
            },
            findPlayerById( playerId ) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            forceDoubeCheck(){
               if (this.match.detail.isDoubles == 1){
                   return true
               }else if(this.match.detail.isDoubles == '' && this.match.id.substring(0, 2) == "MD"){
                   return true
               }else{
                   return false
               }
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.is_wild_card == true )
                    return true

                return false;
            },
            matchState(matchState){

                //needs some actual states for now dummy content

                if( matchState == 'upcoming'  || matchState == ''){
                    return 'Upcoming'
                }

                if( matchState == 'F' || matchState == 'f'){
                    return 'Completed'
                }

                if( matchState == 'P' || matchState == 'p' ){
                    return 'Live Match'
                }

                if (matchState == 'W' || matchState == 'w' ) {
                    return 'Warmup'
                }

                if (matchState == 'C' || matchState == 'c') {
                    return 'On court'
                }

                if (matchState == 'M' || matchState == 'm') {
                    return 'in progress'
                }

                if (matchState == 'S' || matchState == 's') {
                    return 'Suspended'
                }

                if (matchState == 'G' || matchState == 'g') {
                    return 'Players Arrived'
                }

                if (matchState == 'T' || matchState == 't') {
                    return 'Time Announcement'
                }

            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            showStat(match) {

                return this.determineShowStat(match)

            },
            displayStatus(match) {

                return this.determineStatus(match)

            },
            determineShowStat(match) {

                if (match.status == 'Finished') {
                    return true
                }

                if (match.detail.state == 'F' || match.detail.state == 'P') {
                    return true
                }

                return false
            },
            getMatch() {

                axios.get(`${window.feed_ip}/get/${this.assocType(this.match.id)}/${window.tournament}/${this.match.id}`).then(response => {

                    this.feed = response.data
                    this.info = response.data

                    if(this.info.stat.isDoubles == "" && this.feed.id.substring(0, 2) == "MD"){
                        this.info.stat.isDoubles = 1;
                    }

                    // Would be nice to refactor this… nevertheless it works
                    let setInfo = []

                    if (response.data.length != 0) {
                        setInfo.push(...response.data.s1)
                        setInfo.push(...response.data.s2)
                        setInfo.push(...response.data.s3)

                        for (let sv in setInfo[2]) {

                            setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[2][sv])

                        }

                        for (let sv in setInfo[3]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[3][sv])

                        }

                        if (setInfo[4]) {

                            for (let sv in setInfo[4]) {

                                setInfo[0][sv] = parseInt(setInfo[0][sv]) + parseInt(setInfo[4][sv])

                            }

                        }

                        for (let sv in setInfo[5]) {

                            setInfo[1][sv] = parseInt(setInfo[1][sv]) + parseInt(setInfo[5][sv])

                        }

                        this.setInfo = setInfo

                        this.match.detail = this.info.stat
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            },


        }
    }
</script>
